var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnAnalyzedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.814,
    height: 81.804,
    viewBox: "0 0 125.814 81.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-620.285 -429.088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.266,437.617l3.156,8.678-6.843,14.684-2.641-7.31-8.372,16.278a5.182,5.182,0,0,1-4.959,3.156H626.436a5.651,5.651,0,0,1,0-11.3H645.21l12.655-24.876a5.707,5.707,0,0,1,5.426-3.156A5.913,5.913,0,0,1,668.266,437.617Z",
    transform: "translate(0 2.435)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.1,462.7a5.6,5.6,0,0,1-5.667,5.651H689.6a5.718,5.718,0,0,1-5.2-3.381l-1.8-3.848L667.894,493a5.718,5.718,0,0,1-5.2,3.381h-.225a5.877,5.877,0,0,1-5.2-3.832l-2.882-7.97,6.891-14.764,2.093,5.78,14.024-30.3a5.679,5.679,0,0,1,10.4,0l5.426,11.754h26.212A5.757,5.757,0,0,1,725.1,462.7Z",
    transform: "translate(20.499 7.411)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83.517,
    height: 11.304,
    transform: "translate(650.563 505.452) rotate(-65.012)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAnalyzedIcon);
export default __webpack_public_path__ + "static/media/un-analyzed-icon.b341013b1d79e3059852e0d255d2f533.svg";
export { ForwardRef as ReactComponent };